import { createLucideIcon } from 'lucide-react';

export const TimerSolid = createLucideIcon('TimerSolid', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M8.3 1.8c0-.7.6-1.2 1.3-1.2h4.8a1.2 1.2 0 1 1 0 2.4h-1.2v1a9.8 9.8 0 1 1-2.4 0V3H9.6c-.7 0-1.3-.5-1.3-1.2ZM3.1 6.3l1.6-1.6A1.2 1.2 0 1 0 3 3L1.3 4.6a1.2 1.2 0 0 0 1.8 1.7ZM19.3 3c.5-.5 1.3-.5 1.7 0l1.7 1.6a1.2 1.2 0 0 1-1.8 1.7l-1.6-1.6c-.5-.5-.5-1.3 0-1.7ZM12 7.7c.6 0 1 .5 1 1v4h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1v-5c0-.5.4-1 1-1Z',
      fill: 'currentColor',
      stroke: 'none',
      fillRule: 'evenodd',
    },
  ],
]);
